export const createFormState = (data) => {
  return {
    medicineName: data.productName,
    medicineNameBase: data.productName,
    medicineId: data.productId ? data.productId : undefined,
    itemtype: data.itemType.label ? data.itemType.label : null,
    categoryId: data.categoryId,
    medicinePackaging: data.medicinePackaging ? data.medicinePackaging : null,
    therapeutic: data.therapeutic ? data.therapeutic.label : null,
    subtherapeutic: data.subTherapeutic ? data.subTherapeutic : null,
    barcode: data.barcode ? data.barcode : null,
    medicineShortCode: data.medicineShortCode ? data.medicineShortCode : null,
    manufacturerName: data.manufacturer.label ? data.manufacturer.label : null,
    manufacturerId: data.manufacturer.id ? data.manufacturer.id : null,
    medicineGstPer: data.gstPer === "" ? null : data.gstPer,
    minStock: data.minStock ? data.minStock : null,
    maxStock: data.maxStock ? data.maxStock : null,
    hsnCode: data.hsnCode ? data.hsnCode : null,
    rack: data.rack ? data.rack : null,
    remarks: data.remarks,
    istb: data.isTb,
    isLoose: data.isLoose,
    divisor: data.divisor ? data.divisor : null,
    scheduledId: data.scheduleType.id ? data.scheduleType.id : undefined,
    genericDosage: data.genericDosage
      ? data.genericDosage.sort().toString()
      : undefined,
    medicineNameNospace: data.productNameNospace,
    medicineNameDetailed: data.productNameDetailed,
  };
};
